import { render, staticRenderFns } from "./main-business.vue?vue&type=template&id=97b41b48&scoped=true&"
import script from "./main-business.vue?vue&type=script&lang=js&"
export * from "./main-business.vue?vue&type=script&lang=js&"
import style0 from "./main-business.vue?vue&type=style&index=0&id=97b41b48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b41b48",
  null
  
)

export default component.exports